<template>
    <div id="isLive" class="upcamingLive">
        <div v-if="eventNotfound" class="alert alert-info">
            {{ t.error.notfound_fixture }}
        </div>
        <div class="t_head cf">
            <a class="boxTitle">
                <span>
                    Canlı
                </span>
            </a>
            <div class="t_head_but right">
                <div class="left" v-for="sType in Object.values(events).slice(0, 4)"
                @click="activeSport = sType.sportId" :class="activeSport === sType.sportId ? 'on' : ''">{{sType.name}}</div>
            </div>
        </div>
        <div class="t_subhead cf ">
            <div class="w_40 align_c left">Saat</div>
            <div class="left space_lf">&nbsp;</div>
            <div class="type-small">1</div>
            <div class="type-small">X</div>
            <div class="type-small">2</div>
            <div class="w_117 grey_999 pull-right align_c">
                <span class="truncateText">
                    Toplam +/-
                </span>
            </div>
        </div>
        <div class="event-list" :class="$route.name" v-for="sport in sortAByKey(events, 'order')" v-if="!eventNotfound && activeSport == sport.sportId">
            <template v-for="region in sortAByKey(sport.region, 'order')">
                <div class="r-event">
                    <template v-for="comp in region.competition">
                        <template v-for="(match, index) in comp.matches">
                            <div class="event-item" :m="match.eid" v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }">
                                <div class="player-wrapper">
                                    <div class="time-wrapper text-center">
                                    </div>
                                    <div class="team-row" @click="openMatch(match)" :title="region.name">
                                        <div class="player" v-if="match.competitor.oneName">
                                            <div class="pull-left text-center px-2">
                                                {{ match.data.score.home }}
                                            </div>
                                            {{ match.competitor.oneName | slimiter(16) }}
                                        </div>
                                        <span>-</span>
                                        <div class="player" v-if="match.competitor.twoName">

                                            <div class="pull-left text-center px-2">
                                                {{ match.data.score.away }}
                                            </div>
                                            {{ match.competitor.twoName | slimiter(16) }}
                                        </div>
                                    </div>
                                </div>
                                <template v-if="sport.sportId == 1">
                                    <winOdds :odds="match.odds" :match="match"/>
                                    <template v-if="extendedMarkets && match">
                                        <template v-if="match.onLive">
                                            <underOverOdds :odds.sync="match.odds" :match.sync="match"/>
                                        </template>
                                    </template>
                                </template>
                                <template v-if="sport.sportId > 1">
                                    <winOdds :odds.sync="match.odds" :match.sync="match"/>
                                    <template v-if="extendedMarkets">
                                        <underOverOdds :odds.sync="match.odds" :match.sync="match"/>
                                    </template>
                                </template>

                                <div class="h_time-dk">
                                    <div class="time minute_counter" :class="sport.sportId > 1 ? 'sets' : ''">
                                        <template v-if="sport.sportId == 1">
                                            {{ periodTimer(match) }}
                                        </template>
                                        <template v-if="sport.sportId > 1 && match.resultName">
                                                <span :title="match.resultName"
                                                      v-if="match.resultName === 'Not started'">
                                                    N
                                                </span>
                                            <span :title="match.resultName"
                                                  v-else-if="match.resultName === 'Second break' || match.resultName === 'First break' || match.resultName === 'Third break' || match.resultName === 'Break'">
                                                    B
                                                </span>
                                            <span :title="match.resultName" v-else-if="match.resultName === 'Ended'">
                                                    E
                                                </span>
                                            <span :title="match.resultName" v-else>
                                                    {{match.resultName.slice(0,1)}} / 4
                                                </span>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </template>
                </div>

            </template>

        </div>
        <div class="t_foot big cf">
            <div class="button_new_bg inline">
                <router-link :to="{ name: 'LiveBets'}" tag="a" class="button_new">
                    <span>Bütün Karşılaşmalar &amp; Bahisler</span>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import Paginate from 'vuejs-paginate'
    import ContentPlaceholder from 'vue-content-placeholder'
    import betSlip from '@/mixins/betSlip'
    import BetSlipC from '@/components/sportsbook/BetSlip';
    import odd from '@/components/sportsbook/odd';
    import sportIcon from '@/components/ui/asset/sportIcon';
    import mainOdds from '@/components/sportsbook/mainOdds'
    import underOverOdds from '@/components/sportsbook/underOverOdds'
    import handicap from '@/components/sportsbook/handicap'
    import winOdds from '@/components/sportsbook/winOdds'
    export default {
        name: "liveMatchesUpcaming",
        components: {Paginate, BetSlipC, odd, sportIcon, mainOdds, underOverOdds, handicap, winOdds},
        mixins: [betSlip],
        props: {
            filter: {},
            onLive: false,
            extendedMarkets: {
                default: true
            },
            hideCompetitions: false,
            pp: 25,
        },
        data() {
            return {
                activeEvents: [],
                intersectionOptions: {
                    root: null,
                    rootMargin: '0px 0px 0px 0px',
                    threshold: [0, 1] // [0.25, 0.75] if you want a 25% offset!
                },
                loader: false,
                t: this.$root.t,
                events: [],
                selectedOdds: [],
                eventNotfound: false,
                selectedEventDate: false,
                session: session,
                pagination: [],
                page: 1,
                changedOdd: [],
                odd: [],
                matchId: 0,
                matchName: null,
                selectedMatch: {
                    id: 0
                },
                eventIds: null,
                upcoming: null,
                placeholderRows: [

                    {
                        height: '1rem',
                        boxes: [[0, '100%']]
                    },

                ],
                activeSport: 1
            }
        },
        watch: {
            '$route.params'() {
                this.fetchEvents();
            },
            'filter'() {
                this.fetchEvents();
            },
            'matchId'(o, n) {

                if (n == 0) {

                }

                if (o) {
                }

            }
        },
        beforeDestroy() {
            clearInterval(window.EventInterval);
            //clearInterval(window.EventInterval2);
        },
        mounted() {

            window.EventInterval = setInterval(this.fetchEvents, 50000);
            //window.EventInterval2 = setInterval(this.fetchLatestBets, 5000);

            this.fetchEvents();
            this.fetchSelectedBets();

            this.$bus.$on('addBet', ($event) => {

                self.selectedOdds = $event;

            })


            this.$bus.$on('FixtureEventSearch', ($event) => {

                th.eventIds = $event;

                th.fetchEvents()

            })
        },
        methods: {
            onWaypoint ({ el, going, direction }) {
                // going: in, out
                // direction: top, right, bottom, left
                if (going === this.$waypointMap.GOING_IN) {
                    //console.log('waypoint going in!');

                    this.activeEvents.push(el.getAttribute('m'));

                    //console.log(`#${el.getAttribute('m')}`)
                    el.classList.toggle('active', this.$waypointMap.GOING_IN === going)
                }

                if (going === this.$waypointMap.GOING_OUT) {
                    //console.log(direction)
                    this.activeEvents.remByVal(el.getAttribute('m'))
                }

                if (direction === this.$waypointMap.DIRECTION_TOP) {
                    //console.log('waypoint going top!')
                }
            },
            onChangePage(page) {
                this.pagination.current = page;
                this.filter.page = page;

                var upc = this.$route.query.upcoming;
                this.$router.push({});

                this.$router.push({query: {page: page, upcoming: upc}});


                window.scroll(0, 0);
            },
            fetchLatestBets() {
                //th.$bus.$emit('updatedOdd', payload);
                this.$http.get(bsapi + 'api/v1/fixture/streams', {params: {event: this.activeEvents, app: this.$root.app.id}}).then(response => {
                    // get body data
                    if (response.body) {
                        response.body.forEach(data => {
                            this.$bus.$emit('updatedOdd', data);
                        });
                    }

                }, response => {

                })
            },
            fetchEvents() {
                this.eventNotfound = false;

                //this.$bus.$emit('globalLoader', 1);
                this.loader = true;
                this.$http.get(bsapi + 'matches.aspx?page=' + this.page, {
                    params: {
                        per_page: 20,
                        //sport: (this.$route.params.sport) ? [this.$route.params.sport] : null,
                        sport: 1,
                        region: (this.$route.params.region) ? [this.$route.params.region] : null,
                        competition: (this.$route.params.competition) ? [this.$route.params.competition] : null,
                        page: this.$route.query.page,
                        withBets: 1,
                        upcoming: (this.$route.query.upcoming) ? this.$route.query.upcoming : this.filter.upcoming,
                        match: this.eventIds,
                        highlighted: null,
                        onLive: (this.onLive) ? 1 : '',
                        app: this.$root.app.id
                    },

                }).then(response => {
                    // get body data
                    this.events = Object.values(response.body.result.sport);
                    this.$bus.$emit('FixtureEvents', Object.values(this.events).slice(0,4));
                    this.pagination = response.body.pagination;
                    this.loader = false;
                    this.eventNotfound = false;
                    //this.$bus.$emit('globalLoader', 0);

                }, response => {
                    // error callback
                    this.loader = false;
                    this.pagination = false;
                    //this.$bus.$emit('globalLoader', 0);
                })

            },
            /*fetchLiveEvents() {
                var th = this;
                wss.call("fixture/get_matches", {
                    withoutMatch: 0,
                    onLive: 1,
                    per_page: th.filter.per_page,
                    sport: (this.$route.params.sport) ? [this.$route.params.sport] : null
                }).then(
                    function (result) {
                        th.events = result.response.result.sport;
                        th.$bus.$emit('FixtureEvents', th.events);
                        var vats = Object.values(th.sport);

                        vats.forEach(function (entry) {

                            //th.sportCollapseList[entry.sportId] = (typeof th.sportCollapseList[entry.sportId] === 'undefined') ? true : th.sportCollapseList[entry.sportId];

                            Object.values(entry.region).forEach(function (reg) {
                                th.regionCollapseList[reg.regionId] = (typeof th.regionCollapseList[reg.regionId] === 'undefined') ? true : th.regionCollapseList[reg.regionId];

                                Object.values(reg.competition).forEach(function (competition) {

                                    Object.values(competition.matches).forEach(function (match) {

                                        if (match.matchId == th.matchId) {
                                            th.match = match;

                                        }
                                    });
                                });
                            });
                        });

                        ////console.log("RPC Valid!", result);
                    },
                    function (error, desc) {
                        ////console.log("RPC Error", error, desc);
                    }
                );
            },*/
            fetchSelectedBets() {
                this.$getItem('bets', function (key, value) {
                    ////console.log all the kay/value pairs

                    self.selectedOdds = value;

                }, function (err) {
                    self.updateBets([])
                })
            },
            closeOdd() {
            },
            openMatch(m) {
                this.selectedMatch = (this.selectedMatch == m) ? false : m;
                this.$bus.$emit('openMatchOdd', m);
            },
            updateOdd(odd) {
                var change;

                change = null;

                if (this.changedOdd.id == odd.id) {
                    change = (odd.odd > this.changedOdd.n) ? 'down' : 'up';
                    odd.odd = this.changedOdd.n;
                }

                return change;
            },
            toggleMatch(match) {
                match.toggle = (match.toggle) ? false : true;
                //console.log(match.toggle);
            },
            getSportIco(vb) {
                //console.log(this.sportEmoji);
                return this.sportEmoji[vb];
            },
            totalShorts(outcome) {
                return (outcome == 'Over') ? '+' : '-';
            },
            checkSport(sportId) {
                if (this.$route.params.sport == 0) {
                    return true;
                } else if (!this.$route.params.sport) {
                    return true;
                } else {
                    return (sportId == this.$route.params.sport) ? true : false;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

    .LiveBets {
        margin-top: 10px;
    }

    .LiveBets:first-child {
        margin-top: 0;
    }

    .white {
        background: #fff;
    }

    .plus {
        flex: 0 0 5%;
        text-align: center;
        line-height: 30px;
        font-size: 11px;
        font-weight: 500;
        border-left: 1px solid #ccc;
    }

    .plus.nav {
        border-left: none;
    }

    @media (max-width: 1200px) {
        .plus {
            flex: 0 0 8%;
        }
    }

    .upcamingLive {
        margin-bottom: 20px;
    }

    .upcamingLive .h_time-dk {
        top: 25%;
    }

    .fixture_area {
        display: none;
    }

    .competition-header {
        background-color: #3e2950;
        border-bottom: 1px solid rgb(210, 210, 210);
        color: rgb(30, 80, 131);
        display: flex;
        white-space: pre-wrap;
        font-size: 11px;
        text-overflow: ellipsis;
    }

    .event-header {
        color: rgb(255, 255, 255);
        display: flex;
        font-size: 12.5px;
    }

    .event-list .market-type {
        background-color: #fff;
        border-left: 0px;
        flex: 1 1 0%;
        line-height: 30px;
        font-size: 11px;
        text-transform: capitalize;
        font-weight: bolder;
        text-align: center;
        color: #7c7c7c;
    }

    .icon {
        width: 22px;
        height: 22px;
        float: left;
        padding: 2px;
        margin-left: 10px;
        margin-right: 5px;
    }

    .icon svg {
        fill: #000 !important;
    }

    .event-header .event-title {
        text-transform: capitalize;
        color: #7c7c7c;
        line-height: 29px;
        flex: 0 0 30%;
        box-sizing: border-box;
        font-size: 16px;
        font-weight: bold;
    }

    .event-list .event-header {
        background-color: #fff;
        text-transform: uppercase;
        line-height: 23px;
        flex: 0 0 30%;
        box-sizing: border-box;
        color: #7c7c7c;
        height: 30px;
        border-bottom: 3px solid #7c7c7c;
    }

    .competition-header {
        background-color: #fff;
        color: #003366;
        display: flex;
        white-space: pre-wrap;
        font-size: 11px;
        text-overflow: ellipsis;
        height: 30px;
    }

    .competition-header .event-title {
        flex: 0 0 30%;
        align-items: center;
        line-height: 30px;
        font-size: 13px;
        font-weight: bold;
        display: flex;
        color: #7c7c7c;
        overflow: hidden;
        white-space: normal;
        text-overflow: ellipsis;
        box-sizing: border-box;
    }

    .market-labels {
        flex: 1 1 0%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-right: 5px;
    }

    .market-labels div {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        flex: 1;
        font-weight: 500;
        font-size: 11px;
        color: #7c7c7c;
    }

    .event-item {
        display: flex;
        width: 100%;
        background: #ebebeb;
        height: auto;
        position: relative;
        flex-wrap: wrap;
        border-bottom: 1px solid #ccc;
        min-height: 35px;
    }

    .h_event-item {
        display: flex;
        width: 100%;
        height: auto;
        position: relative;
    }

    .event-item:hover {
        background-color: #F2F7F9 !important;
        cursor: pointer;
    }

    .player-wrapper {
        flex: 0 0 30%;
        align-items: center;
        line-height: 23px;
        display: flex;
        overflow: hidden;
        white-space: normal;
        text-overflow: ellipsis;
        box-sizing: border-box;
    }

    .player-wrapper .label {
        float: left;
        width: 100%;
        font-size: 11px;
    }

    .team-row {
        flex: 0 0 80%;
        position: relative;
    }

    .team-row .player {
        float: left;
        width: 50%;
        font-weight: 400;
        font-size: 11px;
        text-align: left;
        color: #333;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .team-row span {
        position: absolute;
        left: 50%;
    }

    .team-row .player:first-child {
        text-align: right;
    }

    .team-row .player .pull-left {
        color: #000;
    }

    .team-row .player:first-child .pull-left {
        float: right;
    }

    .time-wrapper {
        height: 100%;
        min-width: 40px;
        padding: 8px 0;
        font-size: 12px;
        text-align: center;
        color: white;
        font-weight: bold;
        background: #f64835;
        border-left: 2px solid #000;
        margin-right: 2px;
        vertical-align: middle;
        line-height: 11px;
    }

    .event-item .market-labels div {
        background: linear-gradient(to bottom, rgb(254, 254, 254) 0%, rgb(239, 239, 239) 100%);
    }

    .color-scheme-dark .event-item .market-labels div {
        background-image: linear-gradient(180deg, #273048, #303950);
    }

    .color-scheme-dark .competition-header {
        background-image: linear-gradient(180deg, #323c58, #303950);
        box-shadow: 0 5px 15px rgba(22, 22, 35, .1);
        color: #eee
    }

    .r-event .event-item:nth-child(odd) {
        background: #fff;
    }

    .Sportsbook .market-type, .Sportsbook .event-header {
        background-color: #05f0ff;
        color: #37003c;
    }

    .Sportsbook .time-wrapper {
        background: none;
        color: #00c978;
    }

    .hide-med {
        display: static !important;
    }

    .odd-labels {
        margin: 0 5px;
        border-right: 0;
        flex: 1;
    }

    .odd-labels .sp {
        border-right: 0;
        color: #000;
    }

    .time.minute_counter.sets {
    }

    #isLive .seperator {
        height: 23px;
        margin: 10px 0;
        background: url(https://www.totobo1.com/img/live/separator-6C1354130D636377EA33D925A2C1BFEC.png) no-repeat center 0;
        opacity: 0.5;
    }

    .h_time {
        width: 100%;
        font-size: 11px;
        text-align: center;
    }

    .h_time-dk {
        left: 0;
        width: 40px;
        text-align: center;
        font-size: 12px;
        top: 35%;
        color: #fff;
        position: absolute;
        z-index: 4;
    }

    .h_time-extra-odd {
        right: 0;
        width: 40px;
        text-align: center;
        font-size: 12px;
        top: 35%;
        font-weight: bold;
        color: #000;
        position: absolute;
    }

    .t_head {
        border-bottom: 3px solid #f64835!important;
        padding: 0;
        line-height: 29px;
        min-height: 29px;
        background: white;
        border-bottom: 3px solid #7c7c7c;
        color: #7c7c7c;
        font-size: 16px;
        box-sizing: border-box;
        height: 30px;
        width: 100%;
        display: flex;
    }

    .t_head .boxTitle {
        background: url(https://www.totobo1.com/img/lwk-clock-F8F1067EBF70DD26F9C020EDFCF5CCFA.png) no-repeat 8px center white;
        background-size: 18px 18px;
        color: #f64835;
        padding-left: 33px;
        flex: 0 0 50%;
        justify-content: flex-start;
    }

    .cf:before, .cf:after {
        content: "";
        display: table;
    }

    .t_head_but {
        font-size: 11px;
        line-height: 27px;
        color: #000;
        float: right;
        display: flex;
        flex: 0 0 50%;
        justify-content: flex-end;
    }

    .t_head_but .left {
        padding: 0 12px 2px 12px;
        border-left: 1px solid #999;
        cursor: pointer;
    }

    .t_head_but .left.on {
        background: #f64835;
        color: white;
    }

    .t_subhead {
        background: #fff;
        color: #333;
        line-height: 24px;
        position: relative;
        border-bottom: 1px solid #ccc;
    }

    .truncateText {
        line-height: 20px;
    }

    .align_c{
        text-align:center;
    }

    .w_40 {
        width: 40px;
        font-size: 12px;
    }

    .left {
        float: left;
    }

    .space_lf {
        float: left;
        width: 50%;
    }

    .type-small {
        float: left;
        width: 35px;
        line-height: 12px;
        text-align: center;
        color: #999;
        white-space: nowrap;
        overflow: hidden;
        padding-top: 6px;
        font-size: 11px;
    }

    .w_117.grey_999 {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 2px 5px 2px 5px;
        box-sizing: border-box;
        line-height: initial;
        font-size: 11px;
        color: #999;
    }

    .w_117 {
        width: 117px;
    }


    .t_foot {
        background: #fff;
        color: #333;
        border-top: 3px solid #f64835;
    }

    .t_foot .button_new_bg {
        background: none;
        display: block;
        float: right;
        //background: url(https://www.totobo1.com/img/arrow_white-E408B9F4209A9246067D83C48CB6342B.png) no-repeat center left;
    }

    .button_new {
        white-space: nowrap;
        padding-right: 3px;
        cursor: pointer;
        padding-left: 3px;
        display: block;
    }

    .button_new_bg {
        background: url(https://www.totobo1.com/img/arrow_white-E408B9F4209A9246067D83C48CB6342B.png) no-repeat 0 50%;
    }

    .button_new {
        white-space: nowrap;
        padding-right: 3px;
        cursor: pointer;
        padding-left: 3px;
        display: block;
    }

    .button_new span {
        font-size: 12px;
        line-height: 30px;
        color: #666;
        //background: url(https://www.totobo1.com/img/button/button_r-D2B91414E56F1CB3FCAC1F87B2E3F90C.png) no-repeat 100% 50%;
        padding: inherit;
        display: block;
    }

    .button_new:hover span {
        color: #f64835;
    }

</style>


// WEBPACK FOOTER //
// src/components/sportsbook/liveMatchesUpcaming.vue